import React from "react";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules"; // Updated import
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import pfp_madanBhanani from '../img/pfp_madanBhanani.jpg';
import pfp_bharat from '../img/pfp_bharat.jpg';
import pfp_om from '../img/pfp_om.jpg';
import pfp_nitesh from '../img/pfp_nitesh.jpg';

const TestimonialsSection = () => {
    const testimonials = [
        {
            id: 1,
            name: "Madan Bhanani",
            title: "Front-End Developer",
            feedback: "Collaborating with this developer was an outstanding experience. The project was delivered on schedule, with exceptional quality. Highly recommend their services!",
            image: pfp_madanBhanani,
        },
        {
            id: 2,
            name: "Bharat Kumar",
            title: "Front-End Developer",
            feedback: "The web design exceeded all my expectations. The layout is fantastic, and the support provided was prompt and efficient. Truly satisfied!",
            image: pfp_bharat,
        },
        {
            id: 3,
            name: "Ompirkash Suther",
            title: "Front-End Developer & Office Automation Expert",
            feedback: "Amazing work on the e-commerce platform! The UI is intuitive, and the user feedback has been phenomenal. Would definitely collaborate again.",
            image: pfp_om,
        },
        {
            id: 4,
            name: "Nitesh Kumar",
            title: "Front-End Developer",
            feedback: "Highly professional and detail-oriented. My website now stands out with its stunning design and flawless performance. Absolutely recommend their expertise!",
            image: pfp_nitesh,
        },
    ];

    return (
        <section id="testimonials" className="bg-gray-900 text-white py-16 px-6 md:px-12 lg:px-20">
            <div className="max-w-7xl mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
                    Testimonials
                </h2>

                <Swiper
                    modules={[Autoplay, Pagination]}
                    spaceBetween={30}
                    centeredSlides={true}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    loop={true}
                    pagination={{
                        clickable: true,
                    }}
                    breakpoints={{
                        640: {
                            slidesPerView: 1,
                        },
                        1024: {
                            slidesPerView: 2,
                        },
                    }}
                    className="testimonials-slider"
                >
                    {testimonials.map((testimonial) => (
                        <SwiperSlide key={testimonial.id}>
                            <div className="bg-gray-800 p-8 rounded-lg shadow-xl text-center relative mb-12">
                                <FaQuoteLeft className="absolute top-2 left-2 text-4xl text-teal-400" />
                                <FaQuoteRight className="absolute top-2 right-2 text-4xl text-teal-400" />
                                <img
                                    src={testimonial.image}
                                    alt={testimonial.name}
                                    className="w-24 h-24 rounded-full mx-auto mb-4 border-4 border-teal-400"
                                />
                                <p className="text-xl font-semibold mb-4">"{testimonial.feedback}"</p>
                                <p className="text-lg font-semibold text-teal-400">{testimonial.name}</p>
                                <p className="text-gray-400">{testimonial.title}</p>
                            </div>

                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
};

export default TestimonialsSection;
